import { render, staticRenderFns } from "./ProjectListItem.vue?vue&type=template&id=ec1d8e3e&scoped=true"
import script from "./ProjectListItem.vue?vue&type=script&lang=ts"
export * from "./ProjectListItem.vue?vue&type=script&lang=ts"
import style0 from "./ProjectListItem.vue?vue&type=style&index=0&id=ec1d8e3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1d8e3e",
  null
  
)

export default component.exports